import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal } from '@angular/core';
import { ISbStoryData } from '@storyblok/js';
import { StoryblokHelperService } from '../../../services/storyblok-helper.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-article-speech',
  imports: [ButtonDirective, SvgComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './article-speech.component.html',
  styleUrl: './article-speech.component.scss',
})
export class ArticleSpeechComponent {
  private storyblokHelperService = inject(StoryblokHelperService);
  readonly story = input.required<ISbStoryData>();

  utterance: SpeechSynthesisUtterance;
  readonly status = signal<'idle' | 'playing' | 'paused'>('idle');

  isSupported = computed(() => {
    if (typeof window === 'undefined') return false;
    return 'speechSynthesis' in window;
  });

  readonly text = computed(() => {
    const story = this.story();
    const textBlocks = this.storyblokHelperService.getContentTypes(story.content.body.content, ['text']);
    const allText = `${story.content.title}. ${story.content.lead}. ${textBlocks.map(b => b.text).join(' ')}`;
    return allText;
  });

  constructor() {
    effect(() => {
      const text = this.text();

      if (!this.isSupported() || !text) return;
      if (this.utterance) {
        window.speechSynthesis.cancel();
      }
      this.utterance = new SpeechSynthesisUtterance(text);
    });
  }

  play() {
    if (!this.isSupported() || !this.utterance) return;
    window.speechSynthesis.speak(this.utterance);
    this.status.set('playing');
  }

  pause() {
    if (!this.isSupported()) return;
    window.speechSynthesis.cancel();
    this.status.set('idle');
  }
}
